<template>

  <div>
    <!-- Query conditioner -->
    <el-row :gutter="10">
      <el-card shadow="never">
        <!-- Date range picker -->
        <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <div class="d-flex justify-space-between">
              <date-range-picker :from="queryParams.from" :to="queryParams.to" @on-change="applyDateRange"
                  :shortcuts="dateRangeShortcuts" :earliest="dateRangePickerEarliest"></date-range-picker>
              <!-- <el-date-picker type="daterange" v-model="pickedDates"
                range-separator="～" start-placeholder="開始日期" end-placeholder="結束日期"
                :picker-options="datePickerOptions">
              </el-date-picker>  -->
            </div>
        </el-col>
        <el-col :xs="24" :sm="12" :md="6" :lg="6">
          <div class="d-flex justify-space-between">
            <AccountFinder @account-selected="onAccountSelected" ></AccountFinder>  
          </div>
        </el-col>
         <el-col :xs="24" :sm="12" :md="6" :lg="6">
          <div class="d-flex justify-space-between">
            <el-input placeholder="（搜尋交易編號）" v-model="queryParams.orderId"
                maxlength="40" clearable>
            </el-input>   
            <el-button slot="append" @click="onSearchClick">查詢</el-button>
       
          </div>
        </el-col>
       
        <el-col :span="24">
          <div class="d-flex">
            <!-- <el-button type="primary" round icon="now-ui-icons ui-1_zoom-bold"
              @click="onSearchClick" class="ml-4"> 搜尋
            </el-button> -->
            <!-- exports -->
            <el-button round type="danger" icon="now-ui-icons arrows-1_cloud-download-93" @click="doExport">
              匯出報表
            </el-button>
            <br/>

          </div>
        </el-col>
      </el-card>

      <!-- <el-col :span="16"></el-col> -->
    </el-row>
    <br/>
    <el-row :gutter="10">
      <el-col :span="24">
         <data-table ref="table"
          :data="records" :cols="cols" :total="total" :loading="isLoading"
          :on-sort-change="onSortChange" :on-page-request="onPageRequest"
          :rows-per-page-options="[10, 20, 30]" :on-rows-per-page-change="onRowsPerPageChange">

           <div slot="createdAt" slot-scope="{row}">
            {{row.createdAt | toDateTimeString}}
          </div>
          
          <div slot="paidAt" slot-scope="{row}">
            {{row.paidAt | toDateTimeString}}
          </div>
          
          <div slot="amount" slot-scope="{row}">
            <b>{{Number(row.amount).toLocaleString()}}</b>
          </div>

          <div slot="paymentOption" slot-scope="{row}">
            <span v-if="row.paymentOption === 'ddpay'"> 信用卡 </span>
            <span v-else-if="row.paymentOption === 'vac'"> 銀行匯款 </span>
            <!-- <span v-if="row.depositStatus === 'paid' && row.ddpayOrderId"> 線上付款 </span>
            <span v-else-if="row.depositStatus === 'paid'"> 銀行匯款 </span> -->
          </div>
          <div slot="depositStatus" slot-scope="{row}">
            <span v-if="row.depositStatus === 'pending'">
              <i v-if="checkExpiration(row.expiredAt)" class="el-icon-close" style="font-size: 16px; color:red"></i>
              <i v-else class="el-icon-time" style="font-size: 16px; color:orange"></i>
              <span v-if="checkExpiration(row.expiredAt)"> 超過付款期限 </span>
              <span v-else-if="row.paymentOption === 'vac'"> 等待匯款 </span>
              <span v-else> 等待付款 </span>
            </span>
            <span v-else-if="row.depositStatus === 'paid'">
             <i class="el-icon-check" style="font-size: 16px; color:green"></i>
              儲值成功
            </span>
            <span v-else-if="row.depositStatus === 'failed'">
             <i class="el-icon-close" style="font-size: 16px; color:red"></i>
              儲值失敗 
            </span>
            <span v-else-if="row.depositStatus === 'refunded'">
              <i class="el-icon-minus" style="font-size: 16px; color:red"></i>
              已退回
            </span>
            <span v-else-if="row.depositStatus === 'cancelled'">
              <i class="el-icon-minus" style="font-size: 16px; color:red"></i>
              已取消
            </span>
          </div>
          <div slot="invoiceInfo" slot-scope="{row}">
            <span v-if="row.invoiceInfo"> {{row.invoiceInfo.number}} </span>
          </div>
          <div slot="Actions" slot-scope="{row}">
            <el-button type="primary" icon="el-icon-info" circle size="small" @click="showDetail(row)"></el-button>
          </div>
        </data-table>
      </el-col>
    </el-row>
    <!-- Dialog of order detail -->
    <DepositRecordDetail 
      :show.sync="dialog.detail.show" 
      :order-id="dialog.detail.orderId" 
      :ba-id="dialog.detail.baId"
      @cancelled="fetchRecords">
    </DepositRecordDetail>
    <br/>
  </div>
</template>

<script>
import {
  Button
} from 'element-ui';
import DateRangePicker from 'src/components/DateRangePicker';
import {Modal} from 'src/components';
import DataTable from 'src/components/DataTable';
import AccountFinder from './AccountFinder.vue';
import DepositRecordDetail from './DialogDepositRecordDetail.vue'; 

import { UserInfoMixin } from 'src/mixins/user-info.js';

import axios from 'axios';
import moment from 'moment';

export default {
  components: {
    [Button.name]: Button,
    DateRangePicker,
    Modal,
    DataTable,
    AccountFinder,
    DepositRecordDetail
  },
  mixins: [ UserInfoMixin ],

  mounted() {
    this.fetchRecords();
  },

  methods: {
    fetchRecords() {
      console.warn(`[DEPOSIT-RECORDS] Querying deposit records by...`, this.queryParams);
      this.isLoading = true;

      // Resolve some query arguments.
      let fromMoment = moment(this.queryParams.from);
      let toMoment = moment(this.queryParams.to);
      // if (this.userType != 'gaa' && toMoment.diff(fromMoment, 'days') > 31) {
      if (toMoment.diff(fromMoment, 'days') > 31) {
        alert(`查詢日期區間最多一個月（31日）!`);
        this.isLoading = false;
        return;
      }

      // Compose query URL.
      // let apiHost = 'https://apis-dev.ddc.ai/vas/v1/merchants/ddcstore/management/deposit-records';
      // let apiHost = 'http://localhost:3000/vas/v1/merchants/ddcstore/management/deposit-records';
      let apiHost = `${process.env.VUE_APP_APIHOST}/${this.userType}/vas/merchants/ddcstore/deposit-records`;

      let url = `${apiHost}?startIndex=${this.queryParams.startIndex}&limit=${this.queryParams.limit}`;
      // let url = `${process.env.VUE_APP_APIHOST}/${this.userType}/orders?dateType=ts&joinShopNames=true&includeNotes=true&includeStatus=true`
      //     + `&startIndex=${this.queryParams.startIndex}&limit=${this.queryParams.limit}`
      //     + (this.queryParams.sort? `&sort=${this.queryParams.sort}`: '');

    
      //Common search
      url += 
          // Time range
          `&from=${fromMoment.unix()}&to=${toMoment.unix()}`
          + (this.queryParams.timeBased !== 'created_at'? `&timeRangeAttr=${this.queryParams.timeBased}`: '')
          + (this.queryParams.accountId ? `&baId=${this.queryParams.accountId}`: '')
          + (this.queryParams.orderId ? `&orderId=${this.queryParams.orderId}`: '')
        ;

      // Make actual request.
      axios.get(url)
      .then(response => {
        console.log(`[DEPOSIT-RECORDS] Deposit records fetched`, response.data);
        this.total = response.data.total;
        this.records = response.data.deposits;
        return;
      })
      .catch(err => {
        console.error(`[DEPOSIT-RECORDS] Cannot fetch list`, err);
        let errMessage;
        if (err.data && err.data && err.data.code) {
          if (err.data.code == 'DEP001') {
            this.total = 0;
            this.records = [];
            return;
          }
          else if (err.data.code == 'PROTOCOL_SEQUENCE_TIMEOUT')
            errMessage = '資料庫查詢請求逾時！建議縮小查詢範圍。';
          else
            errMessage = err.data.message
        }
        this.$notify.error({
          title: '查詢錯誤',
          message: errMessage
        });
      })
      .finally(() => {
        this.isLoading = false;
      });
    },
    checkExpiration(expiredAt){
      if (!expiredAt) return true;
      let current = moment();
      let expired = moment.unix(expiredAt);
      // console.log(current.format('YYYY/MM/DD HH:mm:ss'), expired.format('YYYY/MM/DD HH:mm:ss'), current.diff(expired) > 0)
      return current.diff(expired) > 0 ? true : false
    },
    doExport() {
      // Resolve some query arguments.
      let fromMoment = moment(this.queryParams.from);
      let toMoment = moment(this.queryParams.to);
      if (toMoment.diff(fromMoment, 'days') > 31) {
        alert(`匯出日期區間最多一個月（31日）!`);
        return;
      }
      let fromTs = fromMoment.unix(), toTs = toMoment.unix();
      if (isNaN(fromTs) || isNaN(toTs)) {
        alert(`所選日期有誤！`);
        return;
      }

      // let apiHost = 'http://localhost:3000/vas/v1/merchants/ddcstore/management/deposit-records/export';
      // let apiHost = 'https://apis-dev.ddc.ai/vas/v1/merchants/ddcstore/management/deposit-records/export';
      // let url = `${apiHost}?from=${fromMoment.unix()}&to=${toMoment.unix()}`;
      // url +=  (this.queryParams.accountId ? `&baId=${this.queryParams.accountId}`: '');
      let apiHost = `${process.env.VUE_APP_APIHOST}/${this.userType}/vas/merchants/ddcstore/deposit-records/export`;
      let data = {
        from: fromMoment.unix(),
        to: toMoment.unix()
      }
      if (this.queryParams.accountId) data.baId = this.queryParams.accountId;
      axios.request({
        method: "get",
        responseType: "blob",
        url: `${apiHost}`,
        params: data
      })
      .then(response => {
        console.log(`[DEPOSIT-RECORDS] Deposit records export`);
        const fileURL = window.URL.createObjectURL(new Blob([response.data]));
        const fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute(
          "download",
          `deposit-records-${new Date().getTime()}.xlsx`
        );
        document.body.appendChild(fileLink);

        fileLink.click();
        window.URL.revokeObjectURL(fileLink);
      })

    },

    applyDateRange(dates) {
      this.queryParams.isDefaultDateRange = false;
      this.queryParams.from = dates[0];
      this.queryParams.to = dates[1];

      //FIXME: Reset limit-offset.
      this.queryParams.startIndex = 0;
      this.fetchRecords();
    },

    onAccountSelected(accountId, accountName) {
      this.queryParams.accountId = accountId || 0;
      // Reset limit-offset and search inputs.
      this.queryParams.startIndex = 0;
      this.fetchRecords();
    },

    onSortChange({prop, key, order}) {
      // console.warn('[ORDERS] DataTable: onSortChange', prop, key, order);
      let ordering = order === 'ascending'? 'asc': 'desc';
      this.queryParams.sort = `${prop}:${ordering}`;
      this.fetchRecords();
    },
    onPageRequest(page) {
      // console.warn(`[ORDERS] DataTable: Trying to fetch page ${page}...`);
      this.queryParams.startIndex = (page - 1) * this.queryParams.limit;
      this.fetchRecords();
    },
    onRowsPerPageChange(rpp) {
      this.queryParams.limit = rpp;
      this.queryParams.startIndex = 0;
      this.fetchRecords();
    },
    onSearchClick() {
      this.queryParams.startIndex = 0;
      this.fetchRecords();
    },
    showDetail(data) {
      this.dialog.detail.orderId = data.depositOrderId;
      this.dialog.detail.baId = data.billingAccountId;
      this.dialog.detail.show = true;
    }
  },

  data() {
    return {
      records: [],
      total: 0,//FIXME: To be updated.
      isLoading: false,

      dateRangeShortcuts: [
        {
          label: '今日',
          from: moment().startOf('day').toDate(),
          // to: new Date()
        },
        {
          label: '昨日',
          from: moment().add(-1, 'days').startOf('day').toDate(),
          to: moment().add(-1, 'days').endOf('day').toDate()
        },
        {
          label: '本週',
          from: moment().startOf('isoWeek').toDate(),
          // to: new Date()
        },
        {
          label: '上週',
          from: moment().add(-1, 'week').startOf('isoWeek').toDate(),
          to: moment().add(-1, 'week').endOf('isoWeek').toDate(),
        },
        {
          label: '本月',
          from: moment().startOf('month').toDate(),
          // to: new Date()
        },
        {
          label: '上個月',
          from: moment().add(-1, 'month').startOf('month').toDate(),
          to: moment().add(-1, 'month').endOf('month').toDate(),
        }
      ],

      queryParams: {
        from: moment().startOf('day').toDate(),
        to: new Date(),
        timeBased: 'created_at',

        startIndex: 0,
        limit: 10,
        
        accountId: undefined,
        orderId: undefined
      },

      cols: [
        {prop: 'id', key: 'depositRecordId', label: 'ID', width: 96, align: 'center', sortable: false},
        {prop: 'orderId', key: 'depositOrderId', label: '交易編號', width: 150, sortable: false},
        {prop: 'billingAccountId', key: 'billingAccountId', label: '帳戶ID', width: 130, sortable: false},
        {prop: 'billingAccountName', key: 'billingAccountName', label: '帳戶名稱', sortable: false},
        {prop: 'memberName', key: 'memberName', label: '操作者', sortable: false},
        {prop: 'createdAt', key: 'createdAt', label: '訂單時間', sortable: false},
        {prop: 'amount', key: 'amount', label: '本次儲值點數', align:'center', sortable: false},
        {prop: 'paidAt', key: 'paidAt', label: '儲值時間', sortable: false},
        {prop: 'paymentOption', key: 'paymentOption', label: '付款方式', width: 130, sortable: false},
        {prop: 'depositStatus', key: 'depositStatus', label: '儲值狀態', width: 130, sortable: false},
        {prop: 'ddpayOrderId', key: 'ddpayOrderId', label: '支付交易編號', sortable: false},
        // {prop: 'invoiceInfo', key: 'invoiceInfo', label: '發票號碼', width: 130, sortable: false},
        {prop: 'Actions', key: '', label: '', width: 72}
      ],

      dialog: {
        detail: {
          show: false,
          orderId: null,
          baId: null
        }
      },

    };
  },

  computed: {
    user() {
      return this.$store.getters.user;
    },
    userType() {
      return this.$store.getters.userType;
    },

    dateRangePickerEarliest() {
      if (this.userType === 'gaa') return 0;
      return moment().add(-3, 'months').startOf('day').unix();
    },

  },

  filters: {
    toDateTimeString(ts) {
      return ts ? moment.unix(ts).format('YYYY/M/D h:mmA') : '';
    },
  }
};
</script>

<style scoped>
i.el-icon-success {color: green; font-size: 20px;}
i.el-icon-remove {color: red; font-size: 20px;}

.row > .col,
.row > [class*="col-"] {
  padding-left: 5px;
  padding-right: 5px;
}
</style>